<template>
    <div>
        <div class="main">
            <!-- Vue tag to add header component -->
            <banner/>
            <!-- Button to edit document in dashboard -->
            <prismic-edit-button :documentId="documentId"/>

            <!-- Template for page title. -->

            <!-- Slices block component -->
            <div class="content-area">
                <slices-block :slices="slices" class="home-slices"/>
            </div>
            <footer-prismic/>
        </div>
    </div>

</template>

<script>

    // imports for all components
    import Banner from "../components/Banner.vue"
    import SlicesBlock from '../components/SlicesBlock.vue';
    import FooterPrismic from "../components/FooterPrismic";


    export default {
        name: 'home',
        components: {
            Banner,
            FooterPrismic,
            SlicesBlock,
        },
        data() {
            return {
                documentId: '',
                meta: {
                    seo_title: null,
                    seo_description: null
                },
                fields: {
                    title: null,
                    page_title: null,
                    tagline: null,
                    image: null,
                    button_link: null,
                    button_label: null
                },
                slices: [],
                show: false,
                languageCode: {}
            }
        },
        metaInfo() {
            return {
                title: this.meta.seo_title,
                meta: [
                    {vmid: 'description', name: 'description', content: this.meta.seo_description}
                ]
            }
        },
        methods: {
            getContent() {
                //Query to get home content
                this.$prismic.client.getSingle('home')
                    .then((document) => {
                        if (document) {
                            this.documentId = document.id;
                            this.fields.page_title = document.data.page_title;
                            this.meta.seo_title = document.data.seo_title;
                            this.meta.seo_description = document.data.seo_description;


                            //Set slices as variable
                            this.slices = document.data.body
                            const languageCode = document.lang;


                            document.alternate_languages.forEach(function (altLang) {
                                const id = altLang.id;
                                const uid = altLang.uid;
                                const type = altLang.type;
                                const languageCode = altLang.lang;
                            });
                        } else {
                            //returns error page
                            this.$router.push({name: 'not-found'})
                        }
                    })
            },
        },

        created() {
            this.getContent()
        }
    }
</script>

<style lang="scss">
    @keyframes slide-up {
        0% {
            opacity: 0;
            top: 60%;
        }

        100% {
            opacity: 1;
            top: 40%;
        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }

        100% {
            opacity: 1;
            transform: none;
        }
    }

    @keyframes fadeInRight {
        0% {
            opacity: 0;
            transform: translate3d(100%, 0, 0);
        }

        100% {
            opacity: 1;
            transform: none;
        }
    }

    body, html {

    }
    .slice.home-slices section {
        margin-bottom: 5rem;

        @media (max-width: 767px) {
            margin-bottom: 0;
        }
    }
    .slice.home-slices section section {
        border: 0;
    }
    /* Media Queries */
    @media (max-width: 767px) {
        .homepage-banner {
            margin: 0 0 40px;
            padding: 10em 0 6em;
        }

        .banner-title {
            font-size: 50px;
            line-height: 50px;
        }

        .text-section-2col {
            -webkit-column-count: 1; /* Chrome, Safari, Opera */
            -moz-column-count: 1; /* Firefox */
            column-count: 1;
            -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
            -moz-column-gap: 40px; /* Firefox */
            column-gap: 40px;
        }

        .quote {
            font-size: 20px;
        }

        .gallery-item {
            -webkit-box-flex: 100%;
            -moz-box-flex: 100%;
            -webkit-flex: 100%;
            -ms-flex: 100%;
            flex: 100%;
        }

        .highlight-left,
        .highlight-right {
            width: 100%;
            float: none;
        }
    }

</style>
